@use "~theme/typography";

.container {
  width: 100%;
}

.header {
  @include typography.heading3;
  margin: 0;
}

.label {
  @include typography.body;
  display: block;
  margin-bottom: 4px;
}

.listItem {
  @include typography.body;
}

.select {
  @include typography.caption;
  width: 100%;
  border-radius: 4px;
  background-color: var(--blue-03-at-30);
  padding: 8px 16px;
}
